/**
 * @file FooterMobile 组件
 * @author yuanyaojia@baijia.com
 * @date 2021-07-13
 */

import React, {useEffect} from 'react';
import {PageFooter} from '@yunying/crow';

import './index.less';

function FooterMobile() {

    return (
        <div className="footer-mobile-container">
            <div className="footer-icon-info">
                <a href="https://www.linkedin.com/company/gaotu/mycompany/?viewAsMember=true" target="_blank" rel="noreferrer">
                    <img
                        className="info-icon"
                        src="//i.gsxcdn.com/1324509445_aq6txm3l.png"
                        alt="linkedin"
                    />
                </a>

                <a href="https://twitter.com/gotu_ir" target="_blank" rel="noreferrer">
                    <img
                        className="info-icon"
                        src="//i.gsxcdn.com/1324509446_zljrrkg4.png"
                        alt="tw"
                    />
                </a>

                <a href="https://q.futunn.com/profile/40000062?lang_code=0" target="_blank" rel="noreferrer">
                    <img
                        className="info-icon"
                        src="//i.gsxcdn.com/1366875754_ewx67cmg.png"
                        alt="ft"
                    />
                </a>

                <a href="https://www.laohu8.com/personal/3536273629510539" target="_blank" rel="noreferrer">
                    <img
                        className="info-icon"
                        src="//i.gsxcdn.com/1366875755_q0kp0dix.png"
                        alt="lh"
                    />
                </a>
            </div>

            <PageFooter copyright="Gaotu Techedu Inc. Copyright Beijing ICP 1406 1840" />

        </div>
    );
}

export default FooterMobile;
